import React from "react";
import { connect } from "react-redux";
import TransactionsAnalytics from "../../components/Analytics/Transactions/Analytics";
import TransactionsReversals from "../../components/Analytics/Reversals/Analytics";
import { Tabs } from "../../components/Tabs";
import language from "../../language";
import TransactionSubType from "../../components/Filters/TransactionSubType";
import PaymentMode from "../../components/Filters/PaymentMode";
import TransactionStatus from "../../components/Filters/TransactionStatus";
import DateFilter from "../../components/Filters/DateFilter";
import icons from "../../constants/icons";
import { Button } from "../../components/Button";
import { onResetFilters } from "../../actions/Filters";

class AnalyticsScreen extends React.Component {
  render() {
    return (
      <div>
        <div className="d-flex flex-wrap gap-2 mb-3">
          <TransactionSubType
            {...this.props.filters}
            title={language[this.props.defaultLanguage].transaction_sub_type}
            button_type="dropdown"
            icon={icons.transaction}
          />
          <PaymentMode
            {...this.props.filters}
            title={language[this.props.defaultLanguage].transaction_status}
            button_type="dropdown"
            icon={icons.receipt}
          />
          <TransactionStatus
            {...this.props.filters}
            title={language[this.props.defaultLanguage].payment_mode}
            button_type="dropdown"
            icon={icons.card}
          />
          <DateFilter
            {...this.props.filters}
            title={language[this.props.defaultLanguage].payment_mode}
            button_type="dropdown"
            icon={icons.calendar}
          />
          {Object.keys(this.props.filters).length > 2 && (
            <Button
              text="Reset Filters"
              className="btn-sm btn-transparent text-danger text-bold"
              onPress={() => this.props.dispatch(onResetFilters())}
            />
          )}
        </div>
        <Tabs
          options={[
            {
              title: language[this.props.defaultLanguage].transactions,
              data: <TransactionsAnalytics />,
            },
            {
              title: language[this.props.defaultLanguage].refund,
              data: <TransactionsReversals />,
            },
          ]}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(AnalyticsScreen);
